export default __webpack_public_path__ + "static/media/cif-py.fc6d9cc6.svg";